import { SHOW_MODAL, CLOSE_MODAL } from '../constants/actionTypes'

export const openModalDialog = (componentName, props) => {
	return { type: SHOW_MODAL, payload: { componentName, props } }
}

export const closeModalDialog = () => {
	return { type: CLOSE_MODAL }
}
